import { NgModule } from '@angular/core';
import { PreloadAllModules, RouterModule, Routes } from '@angular/router';
import { LayoutComponent, PageNotFoundComponent } from '@tvp/common';
import { LandingPageComponent } from './modules/common/components/landing-page/landing-page.component';
import { BrandingGuard } from './modules/common/guards/branding.guard';
import { LandingPageGuard } from './modules/common/guards/landing-page.guard';

const routes: Routes = [
  {
    path: '',
    component: LayoutComponent,
    canActivate: [BrandingGuard],
    children: [
      {
        path: 'appointment',
        loadChildren: () => import('./modules/appointment/appointment.module').then((m) => m.AppointmentModule),
      },
      {
        path: 'branding',
        loadChildren: () => import('./modules/branding/branding.module').then((m) => m.BrandingModule),
      },
      {
        path: '404',
        component: PageNotFoundComponent,
      },
      {
        path: '**',
        component: LandingPageComponent,
        canActivate: [LandingPageGuard],
      },
    ],
  },

  {
    path: '**',
    redirectTo: '',
  },
];

@NgModule({
  imports: [
    RouterModule.forRoot(routes, {
      initialNavigation: 'enabled',
      preloadingStrategy: PreloadAllModules,
      enableTracing: false,
      relativeLinkResolution: 'legacy',
    }),
  ],
  exports: [RouterModule],
})
export class AppRoutingModule {}
